import { svg } from "lit";
const icon = svg `<path d="M21.8805 27.2926L31.9805 17.2311L30.3498 15.6311L21.8703 24.1311L17.6305 19.8811L15.9998 21.4811L21.8805 27.2926ZM2.76904 40.4617V38.1925H45.2305V40.4617H2.76904ZM4.99984 35.4618V7.46191H42.9997V35.4618H4.99984ZM7.26904 33.1926H40.7305V9.73107H7.26904V33.1926Z" fill="currentColor"/>`;
export default icon;
